import axios from 'axios';
import {
  DEPLOYMENT_SETTING_LOAD_DOWNLOAD_CODE_HISTORY_BEGIN,
  DEPLOYMENT_SETTING_LOAD_DOWNLOAD_CODE_HISTORY_SUCCESS,
  DEPLOYMENT_SETTING_LOAD_DOWNLOAD_CODE_HISTORY_FAILURE,
  DEPLOYMENT_SETTING_LOAD_DOWNLOAD_CODE_HISTORY_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadDownloadCodeHistory(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DEPLOYMENT_SETTING_LOAD_DOWNLOAD_CODE_HISTORY_BEGIN,
    });
    const header = builderSurfaceJsonContentHeader(args.projectId, true);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}code-export/history/${args.exportId}`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DEPLOYMENT_SETTING_LOAD_DOWNLOAD_CODE_HISTORY_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: DEPLOYMENT_SETTING_LOAD_DOWNLOAD_CODE_HISTORY_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadDownloadCodeHistoryError() {
  return {
    type: DEPLOYMENT_SETTING_LOAD_DOWNLOAD_CODE_HISTORY_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DEPLOYMENT_SETTING_LOAD_DOWNLOAD_CODE_HISTORY_BEGIN:
      return {
        ...state,
        loadDownloadCodeHistoryPending: true,
        loadDownloadCodeHistoryError: null,
      };

    case DEPLOYMENT_SETTING_LOAD_DOWNLOAD_CODE_HISTORY_SUCCESS:
      return {
        ...state,
        loadDownloadCodeHistoryPending: false,
        loadDownloadCodeHistoryError: null,
        codeDownloadHistories: action.data,
      };

    case DEPLOYMENT_SETTING_LOAD_DOWNLOAD_CODE_HISTORY_FAILURE:
      return {
        ...state,
        loadDownloadCodeHistoryPending: false,
        loadDownloadCodeHistoryError: action.data.error,
      };

    case DEPLOYMENT_SETTING_LOAD_DOWNLOAD_CODE_HISTORY_DISMISS_ERROR:
      return {
        ...state,
        loadDownloadCodeHistoryError: null,
      };

    default:
      return state;
  }
}
